<template>
    <div>
        <slot name="title"></slot>
        <div class="row">
            <div class="col-xs-12 col-sm-9 col-md-8">
                <label v-if="withWeekend" class="sg-textfield-label">
                    <span
                        class="sg-textfield-label-caption"
                        v-html="
                            $t('ess.weekdays', {
                                i18nFallback: 'Weekdays <sub>(Mon - Fri)</sub>',
                            })
                        "
                    ></span>
                </label>
                <multi-row-schedule
                    :id="'schedule-week'"
                    :rows="rowsWeek"
                    :value-title="typeLabel"
                    :value-field="valueField"
                    :value-type="valueType"
                    :first-value="firstValue"
                    :first-value-tooltip="firstValueTooltip"
                    :additional-validators="additionalValidators"
                    @valid-rows="onValidInputWeek"
                    @error="$emit('error', { week: true })"
                ></multi-row-schedule>
                <div v-if="withWeekend">
                    <br />
                    <label class="sg-textfield-label">
                        <span
                            class="sg-textfield-label-caption"
                            v-html="
                                $t('ess.weekends', {
                                    i18nFallback: 'Weekends <sub>(Mon - Sun)</sub>',
                                })
                            "
                        ></span>
                    </label>
                    <multi-row-schedule
                        :id="'schedule-weekend'"
                        :rows="rowsWeekend"
                        :value-title="typeLabel"
                        :value-field="valueField"
                        :value-type="valueType"
                        :first-value="firstValue"
                        :first-value-tooltip="firstValueTooltip"
                        :additional-validators="additionalValidators"
                        @valid-rows="onValidInputWeekend($event)"
                        @error="$emit('error', { weekend: true })"
                    ></multi-row-schedule>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import VrmTextField from '@/vue/components/forms/VrmTextField.vue';
import InputError from '@/vue/components/forms/InputError.vue';
import MultiRowSchedule from '@/vue/components/pages/dynamic-ess/forms/MultiRowSchedule.vue';
import { SCHEDULE_VALUE_TYPES } from '@/vue/components/pages/dynamic-ess/constants.js';

@Component({
    components: {
        VrmTextField,
        InputError,
        MultiRowSchedule,
    },
})
export default class FixedSchedule extends Vue {
    @Prop()
    withWeekend;
    @Prop()
    rowsWeekend;
    @Prop()
    rowsWeek;
    @Prop({ type: String, default: '' })
    valueField;
    @Prop({ type: String, default: SCHEDULE_VALUE_TYPES.NUMBER })
    valueType;
    @Prop({ type: String, default: '' })
    typeLabel;
    @Prop({ type: Array, default: () => [] })
    additionalValidators;
    @Prop({ default: '' })
    firstValue;
    @Prop({ type: String, required: false })
    firstValueTooltip;

    onValidInputWeekend(rows) {
        this.$emit('rows-updated', { weekend: rows });
    }

    onValidInputWeek(rows) {
        this.$emit('rows-updated', { week: rows });
    }
}
</script>
